import React, { useEffect, useRef, useState } from 'react';
import "../assets/styles/home.scss"
import Banner from "../components/Banner";
import Header from "../components/Header";
import { ReactComponent as BarCheck } from '../assets/images/barCheck.svg';

import { ReactComponent as Umbrella } from '../assets/images/umbrella.svg';
import { ReactComponent as TruckBlow } from '../assets/images/truckBlow.svg';
import { ReactComponent as ClockLoop } from '../assets/images/clockLoop.svg';
import { ReactComponent as MapPin } from '../assets/images/mapPin.svg';
import { ReactComponent as WorldPointer } from '../assets/images/worldPointer.svg';
import { ReactComponent as ArrowIcon } from '../assets/images/linkArrow.svg';
import { FaChevronLeft } from "react-icons/fa";
import FaqList from "../components/FaqList";
import Footer from "../components/Footer";
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from "react-router-dom";

function Home() {
    const [step, setStep] = useState(1);
    const intervalRef = useRef(null);
    const isHoveredRef = useRef(false);
    const [activeItems, setActiveItems] = useState([]);
    const [activeFeature, setActiveFeature] = useState(null);
    const [goftinoReady, setGoftinoReady] = useState(false);
    const location = useLocation();

    const navigate = useNavigate();

    const isMobile = window.innerWidth <= 767;

    // Central office coordinates for map functionality
    const centralOffice = { lat: 35.657700772594794, lon: 51.41001187578665 };

  
    const handleSteps = (step) => {
      setStep(step);
    };
  
    const handleFeatureClick = (index) => {
      // setActiveFeature(activeFeature === index);
      console.log(" ");
    };
 
    const faqItems = [
      {
        question: 'سرویس ارسال بار باربری وطن به کدام شهرهای ایران ارسال بار دارد؟',
        answer: `باربری وطن به بیش از ۳۰۰ شهر ایران، ارسال بار دارد. 
    برای یافتن نزدیک‌ترین نمایندگی به مقصد خود، از قسمت «یافتن نمایندگی» شهر مورد نظر خود را انتخاب کنید.`,
        button: 'یافتن نمایندگی',
        link: '/contact#department-map',
      },
      {
        question: 'برای ارسال بارم با باربری وطن باید چه کنم؟',
        answer: `با شماره زیر با ما تماس بگیرید تا در سریع‌ترین زمان، بار شما را از هر نقطه در تهران تحویل بگیریم. 
    همچنین می‌توانید با مراجعه به ترمینال مرکزی باربری وطن در تهران به آدرس زیر، بار خود را به ما تحویل دهید.`,
        button: 'تماس با ما',
        link: '/contact',
        hasSpecialBoxes: true,
        address: 'آدرس باربری وطن: تهران، خیابان شوش، ابتدای خیابان رجایی، پلاک ۷۶۳',
        phone: 'تلفن باربری وطن: ۵۷۵۲۳-۰۲۱'
      },
      {
        question: 'آیا باری که توسط حمل‌ونقل وطن جابجا می‌شود، بیمه می‌شود؟',
        answer: `بار شما، به محض تحویل به ما و صدور رسید، تحت پوشش بیمه قرار گرفته و پرداخت کامل خسارات احتمالی به میزان ارزش اعلامی انجام می‌شود.
    
    بیمه تکمیلی ویژه وطن، خسارات احتمالی در تمامی ابعاد و به‌صورت تمام ریسک را علاوه بر پوشش بیمه‌ای توسط «بیمه ایران»، از محل «صندوق تامین خسارات وطن» جبران خواهد کرد.
    
    همچنین به‌منظور تسریع امور بیمه‌ای، با حذف مراحل بروکراسی، خسارات وارده، حداکثر به‌مدت یک‌ماه از زمان ارائه اسناد و مدارک توسط مشتریان گرامی پرداخت می‌‌گردد.
    
    برای اطلاع از جزییات پوشش بیمه تکمیلی و انواع آن، به صفحه پشتیبانی مراجعه کنید.`,
        button: 'پشتیبانی',
        link: '/contact',
      },
    //   {
    //     question: 'سرویس ارسال بار با وطن اکسپرس چه تفاوتی با سرویس ارسال بار با باربری وطن دارد؟',
    //     answer: `باربری وطن به بیش از ۳۰۰ شهر ایران، ارسال بار دارد. 
    // برای یافتن نزدیک‌ترین نمایندگی به مقصد خود، از قسمت «یافتن نمایندگی» شهر مورد نظر خود را انتخاب کنید.`,
    //     button: 'یافتن نمایندگی',
    //     link: '/contact#department-map',
    //   },
      {
        question: 'از کجا می‌توانم وضعیت و موقعیت بار ارسال شده‌ام با باربری وطن را پیگیری کنم؟',
        answer: `شما می‌توانید از طریق سامانه رهگیری بار باربری وطن، بدون نیاز به تماس با ما، از طریق جستجوی شماره رسید، از وضعیت بار خود آگاه شوید.
همچنین می‌توانید از طریق شماره زیر، با ما تماس گرفته و از وضعیت بار خود آگاه شوید.`,
        button: 'رهگیری بار',
        link: null,
        action: 'openChat',
        hasSpecialBoxes: true,
        phone: 'تلفن باربری وطن: ۵۷۵۲۳-۰۲۱'
      },
    ];
  
    const handleToggleFAQ = (index) => {
      setActiveItems((prevActiveItems) =>
        prevActiveItems.includes(index) ? [] : [index]
      );
    };

    useEffect(() => {
        const startTimer = () => {
          intervalRef.current = setInterval(() => {
            if (!isHoveredRef.current) {
              setStep((prev) => (prev < 4 ? prev + 1 : 1));
            }
          }, 5000); // change every 3s
        };
      
        startTimer();
      
        return () => clearInterval(intervalRef.current);

        
      }, []);

      useEffect(() => {
        const handleGoftinoReady = () => {
          setGoftinoReady(true);
        };
      
        if (window.Goftino) {
          setGoftinoReady(true);
        } else {
          window.addEventListener("goftino_ready", handleGoftinoReady);
        }
      
        return () => {
          window.removeEventListener("goftino_ready", handleGoftinoReady);
        };
      }, []);

      // Scroll to anchors like #destiny when arriving with a hash
      useEffect(() => {
        if (location.hash) {
          const targetId = location.hash.replace('#', '');
          setTimeout(() => {
            const el = document.getElementById(targetId);
            if (el) {
              el.scrollIntoView({ behavior: 'smooth' });
            }
          }, 120);
        }
      }, [location]);

      const openChat = () => {
        // if (goftinoReady && window.Goftino) {
          window.Goftino.open();
        // } else {
        //   console.warn("Goftino is not ready yet.");
        // }
      };

      const handleMouseEnter = () => {
        isHoveredRef.current = true;
      };
      
      const handleMouseLeave = () => {
        isHoveredRef.current = false;
      };

     
  return (
       <div className="home-container">
          <Header/>
    <div className="main-container">
      <Banner openChat={openChat}/>

      <div className="feature-list-container">
     <h2>مزایای ارسال بار با وطن</h2>

      <div className="features-list">
        <div className="feature-col feature-col1">
        <div className={`feature-item feature-item1 ${activeFeature === 1 ? 'active-feature' : ''}`} onClick={() => isMobile && handleFeatureClick(1)}>
        <div className="img-container">
              <BarCheck className="feature-icon"/>
            </div>
            <h5>پذیرش ۲۴ ساعته بار</h5>
            
            <span>پذیرش شبانه‌روزی بار شما در ترمینال مرکزی<span className="symbole">!</span></span>
            <p>ما در هر ساعت از شبانه‌روز و در هر روز هفته، حتی روزهای جمعه و تعطیلات، آماده دریافت بار شما در ترمینال مرکزی وطن هستیم تا در سریع‌ترین زمان به مقصد مورد نظر ارسال کنیم.</p>
            <button className="more-btn">
                <FaChevronLeft style={{marginRight:4}}/>
                بیشتر
            </button>

            <a href='/contact' target='_blank' className="expand-btn">
                <div><FaChevronLeft/></div>
                آدرس باربری وطن
            </a>
        </div>

        <div className={`feature-item feature-item2 ${activeFeature === 2 ? 'active-feature' : ''}`} onClick={() => isMobile && handleFeatureClick(2)}>
        <div className="img-container">
            <MapPin className="feature-icon"/>
            </div>
            <h5>پوشش حداکثری کشور</h5>
            <span>امکان ارسال به تمام استان‌های کشور با بیش از ۳۰۰ شهر<span className="symbole">!</span></span>
            <p>ما برای ارسال بار شما به نقاط مختلف ایران، محدودیتی نداریم، چرا که سامانه حمل‌ونقل وطن، با پوشش حداکثری شهرهای کشور و با در اختیار داشتن بیش از ۳۰۰ شعبه و نمایندگی در سراسر کشور،  می‌تواند بار شما رو به تمامی شهرهای بزرگ و کوچک ارسال کند.</p>
            <button className="more-btn">
                <FaChevronLeft style={{marginRight:4}}/>
                بیشتر
            </button>

            <a href='/contact#department-map' target='_blank' className="expand-btn">
                <div><FaChevronLeft/></div>
                شعب و نمایندگی‌های باربری وطن
            </a>
        </div>

       
        </div>

        <div className="feature-col">

        <div className={`feature-item feature-item3 ${activeFeature === 3 ? 'active-feature' : ''}`} onClick={() => isMobile && handleFeatureClick(3)}>
        <div className="img-container">
                <Umbrella className="feature-icon"/>
            </div>
            <h5>جبران ۱۰۰ درصد خسارت وارده به بار</h5>
            <span>پرداخت کامل خسارت به میزان ارزش اعلامی<span className="symbole">!</span></span>
           <p>
           بیمه تکمیلی ویژه وطن، خسارات احتمالی در تمامی ابعاد و به‌صورت تمام ریسک را علاوه بر پوشش بیمه‌ای توسط «بیمه ایران»، از محل «صندوق تامین خسارات وطن» جبران خواهد کرد.
پوشش بیمه تکمیلی شامل:
 خسارت وارده به محموله بر اثر تصادف وسیله نقلیه
خسارت وارده به محموله بر اثر واژگونی وسیله نقلیه
خسارت وارده به محموله بر اثر حادثه آتش‌سوزی
خسارت وارده به محموله بر اثر سرقت جزئی و کلی
خسارت وارده به محموله بر اثر پرتاب‌شدن از وسیله نقلیه
خسارت وارده به محموله بر اثر خیس‌شدن، آبدیدگی و روندگی
خسارت وارده به محموله بر اثر صدمات و شکستگی
خسارت وارده به محموله ناشی از کسری به هر دلیل
خسارت وارده به محموله ناشی از مفقودی در هر مرحله

به‌منظور تسریع امور بیمه‌ای، با حذف مراحل بروکراسی، خسارات وارده، حداکثر پس از یک‌ماه از زمان ارائه اسناد و مدارک توسط مشتریان گرامی پرداخت می‌‌گردد.
           </p>
            <button className="more-btn">
                <FaChevronLeft style={{marginRight:4}}/>
                بیشتر
            </button>

            <a href='/contact' target='_blank' className="expand-btn">
                <div><FaChevronLeft/></div>
                تماس با پشتیبانی و امور مشتریان
            </a>

        </div>

        <div className={`feature-item feature-item4 ${activeFeature === 4 ? 'active-feature' : ''}`} onClick={() => isMobile && handleFeatureClick(4)}>
        <div className="img-container">
                <ClockLoop className="feature-icon"/>
            </div>
            <h5>ارسال بار در کمترین زمان</h5>
            <span>تحویل بار شما در مقصد، ظرف کمتر از ۲۴ ساعت<span className="symbole">!</span></span>
           <p>
           بار شما را در سریع‌ترین زمان به هر نقطه از ایران ارسال کرده و در کمتر از ۲۴ ساعت در مقصد به گیرنده تحویل می‌دهیم.
           همچنین این مدت زمان برای استان‌های بوشهر، هرمزگان و سیستان‌وبلوچستان، کمتر از ۴۸ ساعت می‌باشد.
           </p>
            <button className="more-btn">
                <FaChevronLeft style={{marginRight:4}}/>
                بیشتر
            </button>

            <a href='/contact#department-map' target='_blank' className="expand-btn">
                <div><FaChevronLeft/></div>
                ارسال بار به شهرستان با وطن
            </a >
        </div>

       

       
        </div>

        <div className="feature-col">
       
        <div className={`feature-item feature-item5 ${activeFeature === 5 ? 'active-feature' : ''}`} onClick={() => isMobile && handleFeatureClick(5)}>
        <div className="img-container">
            <TruckBlow className="feature-icon"/>
            </div>
            <h5>ارسال روزانه بار بدون وقفه</h5>
            <span>ارسال روزانه و بدون وقفه کالا به تمام نقاط کشور <span className="symbole">!</span></span>
            <p>
            پس از پذیرشِ بار در ترمینال مرکزی وطن، بار در همان روز بارگیری شده و بلافاصله به سمت شهر مقصد ارسال می‌شود. این به‌این معنی است که فرقی ندارد شهر مقصدِ بار شما کجاست، بارِ پذیرش شده در وطن، در همان روز به تمام شهرها ارسال خواهد شد و در انبار ترمینال مرکزی معطل نخواهد ماند.
            </p>
            <button className="more-btn">
                <FaChevronLeft style={{marginRight:4}}/>
                بیشتر
            </button>

            <a href='/contact#department-map' target='_blank' className="expand-btn">
                <div><FaChevronLeft/></div>
                حمل بار به شهرستان
            </a>
        </div>

        <div className={`feature-item feature-item6 ${activeFeature === 6 ? 'active-feature' : ''}`} onClick={() => isMobile && handleFeatureClick(6)}>
        <div className="img-container">
            <WorldPointer className="feature-icon"/>
            </div>
            <h5>رهگیری بار به‌صورت آنلاین</h5>
            <span>امکان پیگیری وضعیت و موقعیت بار<span className="symbole">!</span></span>
           <p>
           سامانه رهگیری باربری وطن این امکان را به شما می‌دهد تا بدون نیاز به تماس با ما، از طریق جستجوی شماره رسید بار خود، از وضعیت و موقعیت بار آگاه شوید.
           همچنین می‌توانید به اطلاعات مربوط به بار، نمایندگی شهر مقصد و نیز بخش ثبت شکایت و خسارت دسترسی داشته باشید.
           </p>
            <button className="more-btn">
                <FaChevronLeft style={{marginRight:4}}/>
                بیشتر
            </button>

            <a onClick={openChat} className="expand-btn">
                <div><FaChevronLeft/></div>
               رهگیری بار ارسالی
            </a>
        </div>
        </div>
      </div>

      </div>

      <h2>خدمات ویژه وطن برای ارسال بار</h2>

      <div className="link-cards-container">
        <a href='/vipClient' target='_blank' className="link-card first-link-card">
            <h3>خدمات وطن برای مشتریان ویژه تجاری</h3>
            <span>ارسال بار شرکت‌ها، موسسات و مراکز تجاری، بازرگانی، صنعتی، خدماتی و فروشگاه‌های آنلاین با شرایط ویژه زمانی، نرخی و بیمه‌ای.</span>

            <img src={require('../assets/images/homeTools.png')} alt=""/>

            <button><ArrowIcon className="arrow-icon"/></button>
        </a>

        <a href='/express' target='_blank' className="link-card vip">
            <h3>ارسال کالا با وطن اکسپرس</h3>
            <span>تحویل آنی بار شما در مقصد نهایی، بدون نیاز به عملیات پذیرش و معطلی با بسته‌بندی ویژه و حمل توسط خودروی مخصوص.</span>

            <img src={require('../assets/images/truckSquare.png')}/>

            <button><ArrowIcon className="arrow-icon-vip"/></button>
        </a>
      </div>

      <div id="destiny"></div>

      <div className="choose-destiny-container">
        <h2>مقصد خود را انتخاب کنید و باقی کار را به ما بسپارید</h2>
        <div className="destiny-content">
            <div className="img-container">
            <img src={require(`../assets/images/countryDestiny${step}.png`)} alt=""/>
            </div>
            <div className="destiny-wizard">
                <div   onMouseEnter={handleMouseEnter} 
  onMouseLeave={handleMouseLeave} onClick={() => handleSteps(1)} className={`wizard-step ${step == 1 ? 'active-step' : ''}`}>
                    <div className="title">
                        <span>انتخاب مقصد</span>
                        <div className="number">۱</div>
                    </div>

                    <div className="expand-body">
                        <span>ابتدا نزدیک‌ترین شعبه یا نمایندگی به  مقصدتان  را از میان بیش از ۳۰۰ شعبه و نمایندگی باربری وطن در شهرهای ایران انتخاب نمایید.</span>
                        <a href='/contact#department-map' target='_blank' className="medium-btn">یافتن نمایندگی</a>
                    </div>
                </div>

                <div   onMouseEnter={handleMouseEnter} 
  onMouseLeave={handleMouseLeave} onClick={() => handleSteps(2)} className={`wizard-step ${step == 2 ? 'active-step' : ''}`}>
                    <div className="title">
                        <span>تحویل بار به وطن</span>
                        <div className="number">۲</div>
                    </div>

                    <div className="expand-body">
                        <span>با ما تماس بگیرید تا در سریع‌ترین زمان، بار شما را از هر نقطه در تهران تحویل بگیریم. همچنین می‌توانید با مراجعه به ترمینال مرکزی باربری وطن در تهران، بار خود را به ما تحویل دهید.</span>
                        <a href='/contact' target='_blank' className="medium-btn">تماس با ما</a>
                    </div>
                </div>

                <div   onMouseEnter={handleMouseEnter} 
  onMouseLeave={handleMouseLeave} onClick={() => handleSteps(3)} className={`wizard-step ${step == 3 ? 'active-step' : ''}`}>
                    <div className="title">
                        <span>ارسال بار به نمایندگی شهرستان</span>
                        <div className="number">۳</div>
                    </div>

                    <div className="expand-body">
                        <span>بار شما را با کمکِ به‌روزترین ناوگان برون شهری وطن و در سریع‌ترین زمان ممکن، به نمایندگی باربری وطن در شهر مقصد شما ارسال می‌کنیم.</span>
                        <a href='/contact' target='_blank' className="medium-btn">پشتیبانی</a>
                    </div>
                </div>

                <div   onMouseEnter={handleMouseEnter} 
  onMouseLeave={handleMouseLeave} onClick={() => handleSteps(4)} className={`wizard-step ${step ==4 ? 'active-step' : ''}`}>
                    <div className="title">
                        <span>دریافت بار در مقصد</span>
                        <div className="number">۴</div>
                    </div>

                    <div className="expand-body">
                        <span>پس از ورودِ بارِ شما به نمایندگی باربری وطن در شهر مقصد، جهت نحوه تحویل آن، با شما تماس گرفته می‌‌شود.</span>
                        <a href='/contact#department-map' target='_blank' className="medium-btn">تماس با نمایندگی</a>
                    </div>
                </div>
            </div>
        </div>
      </div>

      </div>


    

      <div className="main-container">

      <h2>تازه‌ترین خبرها</h2>

      <div className="blog-list">
        <div className="blog-item">
            <img src={require('../assets/images/blog-img-1.png')} alt=""/>
            <h5>آغاز به کار خدمت جدید حمل‌ونقل وطن</h5>
            <span>حمل‌ونقل وطن، در راستای ارتقا کیفی خدمات خود، اقدام به راه‌اندازی خدمت جدیدی با عنوان وطن اکسپرس نموده است...</span>
        </div>

        <div className="blog-item">
            <img src={require('../assets/images/blog-img-2.png')} alt=""/>
            <h5>۵۰ سال در کنار حمل‌ونقل وطن</h5>
            <span>در حالی بیش از ۵۰ سال از آغاز به کار حمل‌ونقل وطن می‌گذرد که حالا به بزرگ‌ترین مجموعه حمل‌ونقلی خرده‌بار در کشور تبدیل...</span>
        </div>

        <div className="blog-item">
            <img src={require('../assets/images/blog-img-3.png')} alt=""/>
            <h5>راه‌اندازی وب‌سایت وطن</h5>
            <span>حمل‌ونقل وطن برای پیگیری هرچه بهتر و راحت‌تر وضعیت بار توسط مشتریان، اقدام به راه‌اندازی سامانه مخصوص مشتریان...</span>
        </div>
      </div>



      <FaqList hasTitle={true} faqItems={faqItems} activeItems={activeItems} handleToggleFAQ={handleToggleFAQ} centralOffice={centralOffice} openChat={openChat} />

     
      </div>

<Footer hasFirstSection openChat={openChat}/>
    </div>
  );
}

export default Home;
